import { ScrollToApplyButton } from 'components/ApplyButton/ScrollToApplyButton';
import { DesktopOnly } from 'components/Breakpoint/DesktopOnly';
import { SaveListingButton } from 'components/SaveButton/SaveListingButton';
import { ShareListingButton } from 'components/ShareListingButton/ShareListingButton';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown/ListingActionsDropdown';
import { ListingViewActionButtons } from 'modules/listing/components/ListingView/ActionButtons/ListingViewActionButtons';
import type { ApiEvent } from 'modules/listing/events/api/types/ApiEvent';
import { RsvpButton } from 'modules/listing/events/components/RsvpButton/RsvpButton';
import type { OrgDashboardApiEvent } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiEvent';

type Props = {
  event: ApiEvent | OrgDashboardApiEvent;

  // Save event
  eventSaved: boolean;
  onSaveEvent: () => Promise<void>;
  onUnsaveEvent: () => Promise<void>;

  // Save Org
  orgSaved: boolean;
  shouldShowSaveOrgTooltip: boolean;
  onSaveOrg: () => Promise<void>;
  onUnsaveOrg: () => Promise<void>;
  onDismissSaveOrgTooltip: () => void;
};

export function ViewEventActionButtons({
  event,
  eventSaved,
  onSaveEvent,
  onUnsaveEvent,
  shouldShowSaveOrgTooltip,
  orgSaved,
  onSaveOrg,
  onUnsaveOrg,
  onDismissSaveOrgTooltip,
}: Props) {
  const { id, hasRsvp, type, url, org } = event;

  return (
    <ListingViewActionButtons>
      {hasRsvp ? (
        <RsvpButton listingId={id} />
      ) : (
        <ScrollToApplyButton
          atsIsEnabled={false}
          applied={false}
          size="medium"
        />
      )}

      <SaveListingButton
        listingType={type}
        listingSaved={eventSaved}
        onSaveListing={onSaveEvent}
        onUnsaveListing={onUnsaveEvent}
        orgDetails={{
          shouldShowSaveOrgTooltip,
          onSaveOrg,
          onDismissSaveOrgTooltip,
        }}
      />

      <DesktopOnly>
        <ShareListingButton
          disabled={!url}
          listingId={id}
          listingType={type}
          listingUrl={url}
        />
      </DesktopOnly>

      <ListingActionsDropdown
        listingId={id}
        listingType={type}
        listingUrl={url}
        orgDetails={
          org
            ? {
                orgId: org.id,
                orgName: org.name,
                orgType: org.orgType,
                orgSaved,
                onSaveOrg,
                onUnsaveOrg,
              }
            : null
        }
        markAsAppliedButton={null} // not applicable to events
      />
    </ListingViewActionButtons>
  );
}
